import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=2fe5a3d4&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=ts&"
export * from "./MainPage.vue?vue&type=script&lang=ts&"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=2fe5a3d4&scoped=true&lang=css&"
import style1 from "./MainPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5a3d4",
  null
  
)

export default component.exports